import React from "react";

const PlaySvg = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.02774 14.9993C6.75804 14.9619 6.48684 14.9328 6.21863 14.8858C4.59818 14.6051 3.2168 13.8667 2.07972 12.6819C0.956838 11.5128 0.261291 10.1212 0.0662992 8.51235C-0.252711 5.8807 0.580301 3.6522 2.54815 1.8709C3.66282 0.861542 4.98891 0.264289 6.48012 0.0709289C8.51446 -0.193355 10.3732 0.279221 12.0124 1.51703C13.5476 2.67644 14.4972 4.21661 14.8685 6.10616C14.9193 6.36373 14.9387 6.62801 14.9739 6.88857C14.9806 6.93635 14.991 6.98338 15 7.03116C15 7.34397 15 7.65603 15 7.96885C14.9918 8.00692 14.9783 8.04425 14.9761 8.08232C14.8775 9.36791 14.48 10.5557 13.7598 11.624C12.5645 13.3979 10.9111 14.4901 8.80359 14.8835C8.52641 14.935 8.24551 14.9619 7.96609 15C7.65306 14.9993 7.34077 14.9993 7.02774 14.9993ZM0.746157 7.49403C0.742421 11.2224 3.76293 14.2452 7.49542 14.2475C11.2212 14.2497 14.2372 11.2418 14.2484 7.51269C14.2596 3.78584 11.2443 0.762249 7.50663 0.752543C3.77862 0.742091 0.749892 3.76344 0.746157 7.49403Z"
        fill="#DAA520"
      />
      <path
        d="M5.24366 7.48508C5.24366 6.60189 5.24291 5.7187 5.2444 4.83552C5.24515 4.52047 5.41325 4.30919 5.69714 4.26066C5.86375 4.23229 6.00046 4.30098 6.13345 4.39056C7.12335 5.05127 8.11475 5.71049 9.10539 6.37046C9.43412 6.5892 9.76359 6.80794 10.0916 7.02818C10.4778 7.28798 10.4793 7.71203 10.0916 7.97109C8.76472 8.85727 7.43638 9.74045 6.11029 10.6259C5.92053 10.7528 5.72479 10.7909 5.51933 10.6766C5.31986 10.5662 5.24366 10.3862 5.24366 10.1638C5.2444 9.27086 5.24366 8.37797 5.24366 7.48508ZM9.44756 7.50001C8.29031 6.72881 7.15622 5.97328 6.00644 5.20731C6.00644 6.74448 6.00644 8.25703 6.00644 9.79271C7.15772 9.02599 8.29181 8.26972 9.44756 7.50001Z"
        fill="#DAA520"
      />
    </svg>
  );
};

export default PlaySvg;
